// k3s-staging build target (Story 37.21 Task 5) — the in-cluster nginx image
// for the STAGE k3s stack; twin of environment.k3s-development.ts (see that
// file's header for why every URL here MUST be absolute: the console serves
// at the ROOT of its OWN hostname, so a relative /admin-login resolves
// against admin.staging, hits the static-file nginx instead of the API, and
// fails as 405 Method Not Allowed).
//
// The cross-origin prerequisites mirror dev: nginx CSP names auth.staging in
// connect-src (the Dockerfile.admin-ui API_ORIGIN build arg — CSP is
// build-time), tenant-admin/identity carry https://admin.staging as the
// admin origin in values/stage, and the Admin Application clients list it as
// a CORS origin (Task 6's data-row seeding — the dev dead-CORS lesson).
// Auth state is a Bearer token, not a cookie, so there is no SameSite concern.
export const environment = {
  production: false,
  envLong: 'staging',
  oauthBaseUrl: 'https://auth.staging.emjo-consulting.dk',
  tenantAdminApiUrl: 'https://auth.staging.emjo-consulting.dk',
  callbackUrl: '',
  // 46.10 code review: pointed at the RETIRED /brand-site path mount. The
  // brand site moved to its own ianua.<env> hostname and the path entry was
  // dropped from the auth host, so the two in-product "Docs" links built
  // from this value (pages-editor + emails-editor -> ${brandSiteUrl}/docs/...)
  // fell through to emjo-login's SPA catch-all and served the SIGN-IN app at
  // 200 — a blank page, since that router has no wildcard route. Live-broken
  // in all three environments until this fix; the docs themselves were fine
  // at ianua.<env>/docs/*. The story's residue sweep could not see this: it
  // scanned the brand-site dist only, not consumers in other apps.
  // Consumers today (53.1): pages-editor + emails-editor (${brandSiteUrl}/docs/...)
  // and the sidebar Documentation link (${brandSiteUrl}/docs) — a host move
  // (53.7 on prod) must carry all three.
  brandSiteUrl: 'https://ianua.staging.emjo-consulting.dk',
};
